import { Component, OnInit } from '@angular/core';
import { ReposicionService } from './../../../reposicion.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BranchStoreService } from 'src/app/pages/operations/reposicion/components/branch-store.service';

interface Sucursal {
  codigo: string;
  nombre: string;
  seleccionada?: boolean;
}

interface BranchStore {
  id: string;
  name: string;
  establishmentCode: string;
  address: string;
  deleted: string;
}

@Component({
  selector: 'app-estado-sucursales',
  templateUrl: './estado-sucursales.component.html',
  styleUrls: ['./estado-sucursales.component.css']
})
export class EstadoSucursalesComponent implements OnInit {
  errorMensaje = '';

  sucursales: Sucursal[] = [];

  loading = true;

  constructor(
    private reposicionService: ReposicionService,
    private router: Router,
    private route: ActivatedRoute,
    private branchStoreService: BranchStoreService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.loading = true;

      const resp = await this.branchStoreService.getByBusiness();

      const data = (resp.data as BranchStore[]).filter(
        (s) => s.deleted === '0'
      );

      this.sucursales = data.map((s) => ({
        codigo: s.establishmentCode,
        nombre: s.address,
        seleccionada: false
      }));

      this.reposicionService.sucursalesSeleccionadas$.subscribe(
        (seleccionadas) => {
          this.sucursales.forEach((s) => {
            s.seleccionada = seleccionadas.includes(s.codigo);
          });
        }
      );
    } catch (error) {
      console.error('Error cargando sucursales', error);
    } finally {
      this.loading = false;
    }
  }

  toggleSucursal(sucursal: Sucursal) {
    sucursal.seleccionada = !sucursal.seleccionada;

    this.actualizarSeleccion();
  }

  seleccionarTodos() {
    const todosSeleccionados = this.sucursales.every((s) => s.seleccionada);

    this.sucursales.forEach((s) => {
      s.seleccionada = !todosSeleccionados;
    });

    this.actualizarSeleccion();
  }

  actualizarSeleccion() {
    const seleccionadas = this.sucursales
      .filter((s) => s.seleccionada)
      .map((s) => s.codigo);

    this.reposicionService.setSucursalesSeleccionadas(seleccionadas);
  }

  iniciarReposicion() {
    const seleccionadas = this.sucursales.filter((s) => s.seleccionada);

    if (seleccionadas.length === 0) {
      this.errorMensaje =
        'Debes seleccionar al menos una sucursal para iniciar la reposición.';

      setTimeout(() => {
        this.errorMensaje = '';
      }, 5000);

      return;
    }

    this.errorMensaje = '';

    this.router.navigate(['../asistida'], { relativeTo: this.route });
  }

  get totalSucursales(): number {
    return this.sucursales.length;
  }

  get totalSeleccionadas(): number {
    return this.sucursales.filter((s) => s.seleccionada).length;
  }
}
